const encodeHex = require("crypto-js/enc-hex");
const hmacSHA256 = require("crypto-js/hmac-sha256");

/**
 * Returns a HMAC-SHA256 signature on the data URL.
 *
 * Takes a data URL (any string really), and a secret, and signs it.
 * Returns the result in hexdigest form.
 */
function signDataUrl(imgDataUrl: string, secret: string) {
  const digestBinary = hmacSHA256(imgDataUrl, secret);
  return encodeHex.stringify(digestBinary);
}

// Adapted from https://stackoverflow.com/questions/12168909/blob-from-dataurl
export function dataUrlToByteArray(dataUrl: string) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataUrl.split(",")[1]);

  // write the bytes of the string to an ArrayBuffer
  const buffer = new ArrayBuffer(byteString.length);

  // create an array view into the buffer
  const array = new Uint8Array(buffer);

  // set the bytes of the array to the correct values
  for (let i = 0; i < byteString.length; i += 1) {
    array[i] = byteString.charCodeAt(i);
  }

  return array;
}

export function getFileFromDataUrl(dataUrl: string, fileName: string, mimeType = "application/octet-stream") {
  const uint8Array = dataUrlToByteArray(dataUrl);
  const blob = new Blob([uint8Array], { type: mimeType });
  return new File([blob], fileName, { type: mimeType });
}

export function imageArrayToUrl(imageArray: Uint8Array) {
  return URL.createObjectURL(new Blob([imageArray.buffer], { type: "image/jpeg" }));
}

export default signDataUrl;
